// Copyright (c) 2016 Deere & Company

import {
    addAmountOfUseRecord,
    addFileForUpdateAmountOfUse,
    deleteFileAddAmountOfUse,
    resetAddAmountPerUnitMeasurements,
    updateAmountUnitInMeasurementReading,
    updateUnitMeasurements
} from '../../../shared/action-creators/update-unit-measurements';
import {
    addComponents,
    addFile,
    deleteComponents,
    updateBaseMachineComponents,
    updateBaseMachineImplements,
    updatePurchaseOrder
} from './base-machine-implements';
import {
    createComponent,
    updateComponentToAdd
} from './component-to-add';
import {
    createOption,
    updateOptionToAdd
} from './option-to-add';
import {
    deleteProductComponent,
    updateComponents
} from './components';
import {
    deleteProductOption,
    updateOptionCodes
} from './option-codes';
import {
    onCreateClaim,
    updateCreateClaimModalVisibility
} from './create-claim-modal-visibility';
import {
    resetProductDetails,
    updateProductDetails
} from './product-details';
import {
    toggleAccordion,
    toggleAccordions
} from './accordions';
import {
    updateAmountOfUseModalVisibility,
    updateEditAmountOfUseModalVisibility
} from './amount-of-use-modal-visibility';
import customerDetailsActionCreators from '../../../customer/details/action-creators';
import {customerPanelRegistration} from '../../../shared/action-creators/customer-panel-registration';
import {deleteFile} from './delete-file';
import {readClaimTypes} from './get-claim-types';
import {readComponentCodes} from './component-codes';
import {readExternalNotes} from './external-notes';
import {readPartDetails} from './read-part-details';
import {resetCkcCustomerFailure} from '../../../shared/action-creators/customer-failed';
import {resetCustomerDetails} from './reset-customer-details';
import {resetLatestPerUnitMeasurements} from '../../../shared/action-creators/latest-per-unit-measurements';
import sharedActionCreators from '../../shared/action-creators';
import {undoRegistration} from './undo-registration-history';
import {updateAmountOfUseHistory} from './amount-of-use-history';
import {updateClaims} from './claims';
import {updateCustomer} from './customer';
import {updateImplements} from './implements';
import {updateIncentivePrograms} from './incentive-programs';
import {updateMaintenancePlans} from './maintenance-plan';
import {updatePIP} from './pip';
import {updateProductDetailsStatusChangeModal} from './product-detail-status-change-modal';
import {updateRegistrationHistory} from './registration-history';
import {updateWarranties} from './warranties';

export default {
    ...customerDetailsActionCreators,
    ...sharedActionCreators,
    addAmountOfUseRecord,
    addComponents,
    addFile,
    addFileForUpdateAmountOfUse,
    createComponent,
    createOption,
    customerPanelRegistration,
    deleteComponents,
    deleteFile,
    deleteFileAddAmountOfUse,
    deleteProductComponent,
    deleteProductOption,
    onCreateClaim,
    readClaimTypes,
    readComponentCodes,
    readExternalNotes,
    readPartDetails,
    resetAddAmountPerUnitMeasurements,
    resetCkcCustomerFailure,
    resetCustomerDetails,
    resetLatestPerUnitMeasurements,
    resetProductDetails,
    toggleAccordion,
    toggleAccordions,
    undoRegistration,
    updateAmountOfUseHistory,
    updateAmountOfUseModalVisibility,
    updateAmountUnitInMeasurementReading,
    updateBaseMachineComponents,
    updateBaseMachineImplements,
    updateClaims,
    updateComponentToAdd,
    updateComponents,
    updateCreateClaimModalVisibility,
    updateCustomer,
    updateEditAmountOfUseModalVisibility,
    updateImplements,
    updateIncentivePrograms,
    updateMaintenancePlans,
    updateOptionCodes,
    updateOptionToAdd,
    updatePIP,
    updateProductDetails,
    updateProductDetailsStatusChangeModal,
    updatePurchaseOrder,
    updateRegistrationHistory,
    updateUnitMeasurements,
    updateWarranties
};



// WEBPACK FOOTER //
// ./src/product/details/action-creators/index.js